/**
 * FeedbackBox — styled feedback shown after the user answers.
 *
 * Three states: pending (instruction text), correct, wrong. The exercise card
 * uses this beneath the option buttons.
 */

import { type ReactNode } from "react";

export type FeedbackState = "pending" | "correct" | "wrong";

export interface FeedbackBoxProps {
  state: FeedbackState;
  children: ReactNode;
}

export function FeedbackBox({ state, children }: FeedbackBoxProps): ReactNode {
  const cls = {
    pending: "bg-paperWarm border-ink/20 text-inkSoft",
    correct: "bg-success/10 border-success text-ink",
    wrong: "bg-paperWarm border-ink text-ink",
  }[state];
  return (
    <div
      className={`min-h-[3.5rem] px-4 py-3 border-l-2 font-serif italic text-base ${cls} flex items-center`}
      role="status"
      aria-live="polite"
    >
      {children}
    </div>
  );
}
